import { IUserData } from 'Foundation/User/UserContextModels';

export class StringHelper {
  static replaceTokens = function (value: string, userData: IUserData) {
    if (value.indexOf('{userId}') > -1 && userData?.dpecid && userData?.userId) {
      let username: string = userData.isAgent() ? userData.dpecid : userData.userId.substr(0, 8);
      value = value.replace('{userId}', username);
    }
    if (value.indexOf('{userid}') > -1 && userData?.dpecid && userData?.userId) {
      let username: string = userData.isAgent() ? userData.dpecid : userData.userId.substr(0, 8);
      value = value.replace('{userid}', username);
    }
    if (value.indexOf('{statcode}') > -1 && userData?.selectedStatCodeData.SubStat)
      value = value.replace('{statcode}', userData?.selectedStatCodeData.SubStat);

    if (value.indexOf('{state}') > -1 && userData?.state)
      value = value.replace('{state}', userData.state.toLowerCase());

    return value;
  };
  /**
   * Add parameter to a url string and keeps existing parameters and hash
   * @param url
   * @param parameterName
   * @param parameterValue
   * @param atStart - Should add as first parameter
   * @returns url with parameter added
   */
  static addUrlParameter = function (
    url: string,
    parameterName: string,
    parameterValue: string,
    atStart: boolean,
  ): string {
    let replaceDuplicates: boolean = true;
    let urlhash = '';
    let cl: number;
    if (url.indexOf('#') > 0) {
      cl = url.indexOf('#');
      urlhash = url.substring(url.indexOf('#'), url.length);
    } else {
      cl = url.length;
    }
    let sourceUrl = url.substring(0, cl);
    var urlParts = sourceUrl.split('?');
    var newQueryString = '';

    if (urlParts.length > 1) {
      var parameters = urlParts[1].split('&');
      for (var i = 0; i < parameters.length; i++) {
        var parameterParts = parameters[i].split('=');
        if (!(replaceDuplicates && parameterParts[0] === parameterName)) {
          if (newQueryString === '') newQueryString = '?';
          else newQueryString += '&';
          newQueryString += parameterParts[0] + '=' + (parameterParts[1] ? parameterParts[1] : '');
        }
      }
    }
    if (newQueryString === '') newQueryString = '?';

    if (atStart) {
      newQueryString =
        '?' +
        parameterName +
        '=' +
        parameterValue +
        (newQueryString.length > 1 ? '&' + newQueryString.substring(1) : '');
    } else {
      if (newQueryString !== '' && newQueryString !== '?') newQueryString += '&';
      newQueryString += parameterName + '=' + (parameterValue ? parameterValue : '');
    }
    return urlParts[0] + newQueryString + urlhash;
  };

  //regex ref:
  //https://www.geeksforgeeks.org/how-to-validate-guid-globally-unique-identifier-using-regular-expression/
  static isGuid = function (value: string | undefined): boolean {
    let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);

    if (!value) return false;

    if (regex.test(value)) return true;
    else return false;
  };
  static formatStatCode = function (statCode: string): string {
    return statCode.length == 8
      ? `${statCode.substring(0, 2)}-${statCode.substring(2, 4)}-${statCode.substring(4)}`
      : statCode;
  };
  static hasNonEmptyString = (s?: string | null) => !!s && s.trim().length > 0;
}
